 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXT9780062292742_COVER from '@/components/text/9780062292742_Cover'
 import LOVE_1 from '@/components/love_1'
 import TEXT9780062292742_TITLEPAGE from '@/components/text/9780062292742_Titlepage'
 import TEXT9780062292742_CONTENTS from '@/components/text/9780062292742_Contents'
 import TEXT9780062292742_FROM_EDITOR from '@/components/text/9780062292742_From_Editor'
 import TEXT9780062292742_PROLOGUE from '@/components/text/9780062292742_Prologue'
 import TEXT9780062292742_CHAPTER_1 from '@/components/text/9780062292742_Chapter_1'
 import TEXT9780062292742_CHAPTER_2 from '@/components/text/9780062292742_Chapter_2'
 import TEXT9780062292742_CHAPTER_3 from '@/components/text/9780062292742_Chapter_3'
 import TEXT9780062292742_CHAPTER_4 from '@/components/text/9780062292742_Chapter_4'
 import TEXT9780062292742_CHAPTER_5 from '@/components/text/9780062292742_Chapter_5'
 import TEXT9780062292742_CHAPTER_6 from '@/components/text/9780062292742_Chapter_6'
 import TEXT9780062292742_CHAPTER_7 from '@/components/text/9780062292742_Chapter_7'
 import TEXT9780062292742_CHAPTER_8 from '@/components/text/9780062292742_Chapter_8'
 import TEXT9780062292742_EPILOGUE from '@/components/text/9780062292742_Epilogue'
 import LOVE_2 from '@/components/love_2'
 import TEXT9780062292742_PHOTOGRAPHS from '@/components/text/9780062292742_Photographs'
 import TEXT9780062292742_ACKNOWLEDGMENTS from '@/components/text/9780062292742_Acknowledgments'
 import TEXT9780062292742_ABOUT_CONTRIBUTORS from '@/components/text/9780062292742_About_Contributors'
 import TEXT9780062292742_CREDITS from '@/components/text/9780062292742_Credits'
 import TEXT9780062292742_COPYRIGHT from '@/components/text/9780062292742_Copyright'
 import TEXTABOUT_THE_PUBLISHER from '@/components/text/About_the_Publisher'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/text/9780062292742_Contents",
 			"name" : "text/9780062292742_Contents",
 			"component" : TEXT9780062292742_CONTENTS
 		},
 		{
 			"path" : "/text/9780062292742_From_Editor",
 			"name" : "text/9780062292742_From_Editor",
 			"component" : TEXT9780062292742_FROM_EDITOR
 		},
 		{
 			"path" : "/text/9780062292742_Prologue",
 			"name" : "text/9780062292742_Prologue",
 			"component" : TEXT9780062292742_PROLOGUE
 		},
 		{
 			"path" : "/text/9780062292742_Chapter_1",
 			"name" : "text/9780062292742_Chapter_1",
 			"component" : TEXT9780062292742_CHAPTER_1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js